import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline, Box } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

// Contexts
import { TelegramAuthProvider } from './contexts/TelegramAuthContext';

// Components
import TelegramRoute from './components/TelegramRoute/TelegramRoute';
import ArabicLessons from './pages/ArabicLessons/ArabicLessons';
import VersionChecker from './components/VersionChecker';
import {readerRoutes} from './components/ReaderRoutes';

// Theme configuration - Islamic theme
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#2E7D32', // Зеленый - исламский цвет
      light: '#4CAF50',
      dark: '#1B5E20',
    },
    secondary: {
      main: '#FFC107', // Золотой
      light: '#FFD54F',
      dark: '#FFA000',
    },
    background: {
      default: '#F5F5F5',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Noto Naskh Arabic", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
          '&:hover': {
            boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          fontWeight: 500,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
  },
});

/**
 * AppLessonsOnly - Минимальное приложение только с арабскими уроками
 * Для использования в Telegram WebApp
 */
function AppLessonsOnly() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
        <Router>
          <TelegramAuthProvider>
            <VersionChecker />
            <Box sx={{ minHeight: '100vh', backgroundColor: 'background.default' }}>
              <Routes>
                {readerRoutes}
                <Route path="/arabic-lessons" element={<TelegramRoute><ArabicLessons/></TelegramRoute>} />
                {/* Главная страница - арабские уроки */}
                <Route path="/" element={
                  <TelegramRoute>
                    <ArabicLessons />
                  </TelegramRoute>
                } />
                
                {/* Дополнительные роуты для уроков */}
                <Route path="/lessons" element={
                  <TelegramRoute>
                    <ArabicLessons />
                  </TelegramRoute>
                } />
                
                <Route path="/lessons/:letter" element={
                  <TelegramRoute>
                    <ArabicLessons />
                  </TelegramRoute>
                } />
                
                {/* Перенаправление всех остальных путей на главную */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Box>
          </TelegramAuthProvider>
        </Router>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default AppLessonsOnly;

